<template>
  <div class="left">
    <div class="title">音视频管控平台</div>
    <el-row class="tac">
      <el-col :span="24">
        <el-menu router :default-active="this.$route.fullPath" unique-opened class="el-menu-vertical-demo"
          @select="handleSelect" @open="handleOpen" @close="handleClose" background-color="#040848" text-color="#fff"
          active-text-color="#ffd04b">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-connection"></i>
              <span>配置功能</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/monitor" route="/monitor">
                <i class="el-icon-video-camera"></i>
                <span>监控</span>
              </el-menu-item>
              <el-menu-item index="1-2" disabled>
                <!-- <el-menu-item index="/form" route="/form"> -->
                <i class="el-icon-loading"></i>
                <span>信号源</span>
              </el-menu-item>
              <!-- <el-menu-item index="/iot" route="/iot">
                <i class="el-icon-video-camera"></i>
                <span>物联网设备</span>
              </el-menu-item> -->
              <el-submenu index="/iot" route="/iot" style="position: relative;">
                <template slot="title">
                  <i class="el-icon-monitor"></i>
                  <span>物联网设备</span>
                  <i class="el-icon-circle-plus" @click="addMenu()"></i>
                </template>
                <el-menu-item style="position: relative;" v-for="(item, index) in NavList" :key="item.deviceGroupID"
                  :index="'/iot' + '?id=' + item.deviceGroupID" @click="QueryDevice(item)">
                  <i class="el-icon-folder-opened"></i>
                  <span style="display: inline-block;width: 100px;overflow: hidden;text-overflow: ellipsis;">{{
                    item.deviceGroupName }}</span>
                  <i class="el-icon-remove" @click="delMenu(index)"></i>
                  <i class="el-icon-edit" @click="editMenu(index)"></i>
                </el-menu-item>
                <!-- <el-menu-item index="/iot1" route="/iot1" style="position: relative;">
                  <i class="el-icon-folder-add"></i>
                  <span>客厅</span>
                  <i class="el-icon-remove" @click="delMenu()"></i>
                  <i class="el-icon-edit" @click="editMenu()"></i>
                </el-menu-item> -->
              </el-submenu>
              <el-menu-item index="1-4" disabled>
                <i class="el-icon-thumb"></i>
                <span>应用系统</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>辅助功能</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-1" disabled>
                <i class="el-icon-mobile-phone"></i>
                <span>设备运维</span>
              </el-menu-item>
              <!-- <el-menu-item index="2-2" disabled>
                <i class="el-icon-place"></i>
                <span>物联网设备功能调试</span>
              </el-menu-item> -->
              <el-menu-item index="2-3" disabled>
                <i class="el-icon-circle-check"></i>
                <span>日志</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script src="https://unpkg.com/element-ui/lib/index.js"></script>
  <script>
export default {
  inject: ['reload'],
  data() {
    return {
      NavList: [],
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      if(this.NavList.length==0&&keyPath[1]=='/iot'){
        this.$message('请先点击加号，添加设备组');
      }
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    addMenu() {
      event.stopPropagation();
      this.$prompt('设备组名称', '新建', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^ ]+$/,
        inputErrorMessage: '名称格式不正确'
      }).then(({ value }) => {
        this.$apiFun.postHardwareGroup(
          { DeviceGroupName: value })
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '创建成功: ' + value
              });
              this.getDeviceGroupList();
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消创建'
        });
      });
    },
    delMenu(index) {
      event.stopPropagation();
      this.$confirm('此操作将永久删除该设备组, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$apiFun.getDelHardwareGroup(
          { DeviceGroupID: this.NavList[index].deviceGroupID })
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getDeviceGroupList();
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    editMenu(index) {
      event.stopPropagation();
      this.$prompt('设备组名称', '修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: this.NavList[index].deviceGroupName,
        inputPattern: /^[^ ]+$/,
        inputErrorMessage: '名称格式不正确',
      }).then(({ value }) => {
        this.$apiFun.postHardwareGroup(
          { DeviceGroupName: value, DeviceGroupID: this.NavList[index].deviceGroupID })
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '修改成功: ' + value
              });
              this.getDeviceGroupList();
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        });
      });
    },
    getDeviceGroupList() {
      this.$apiFun.getSelectHardwareGroup()
        .then(res => {
          if (res.code == 200) {
            this.NavList = res.data;
          }
        })
    },
    QueryDevice() {
      var id = this.$route.query.id
      this.$apiFun.getSelectHW({ DeviceGroupID: id })
        .then(res => {
          if (res.code == 200) {
            var DeviceList = res.data;
            var Page = 1;
            this.$emit("DeviceList", DeviceList);
            this.$emit("Page", Page);
          }
        })
    },
    handleSelect(keyPath) {
      sessionStorage.setItem('keyPath', keyPath);
      var Page = 1;
      this.$emit("Page", Page);
    }
  },
  mounted() {
      // 事件监听滚动条
      window.addEventListener('scroll', this.watchScroll)
    this.$nextTick(() => {
      // 异步操作 
      this.getDeviceGroupList();
      if (this.$route.path == '/iot') {
        this.QueryDevice()
      }
    })
  },
}
  </script>
<style lang="less" scoped>
.left {
  min-width: 302px;
  height: 100%;
  background: #040848;
}

.title {
  height: 81px;
  line-height: 81px;
  text-align: center;
  font-size: 30px;
  color: #fff;

  @font-face {
    font-family: "华康新综艺";
    src: url("../assets/fonts/huakangxinzongyi.ttf");
  }

  font-family: "华康新综艺";
}

.el-menu {
  border: none !important;
}

.el-icon-circle-plus {
  position: absolute;
  right: 40px;
  top: 19px;
}

.el-icon-circle-plus:hover {
  color: gainsboro;
}

.el-icon-remove {
  position: absolute;
  right: 40px;
  top: 16px;
}

.el-icon-edit {
  position: absolute;
  right: 80px;
  top: 16px;
}
</style>
  